import Data from './Data';

const TwitterSidebar = (props) => {
  return <Data {...props} />;
};

export default TwitterSidebar;
